import MPagination from './Pagination.vue';

export default MPagination;
